export const baseBranch = process.env['GITHUB_BRANCH'] || 'master';
